<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <!-- force render tab because need validate all tab -->
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <Tabs v-model:activeKey="menuContext.tabKey" type="card">
            <TabPane key="Requestor" :tab="$t('views.request.requestor.title')" :forceRender="true">
                <RequestorForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataTempKey="refHazLicenseTemp"
                        :userAuthorizeRole="has({ menuContext, key: 'forHazLicenseNotice' }) ? 'HAZ_LICENSE_NOTICE' : 'HAZ_LICENSE'"
                        :isLoading="isLoading"
                ></RequestorForm>
            </TabPane>
            <TabPane key="HazLicenseDetail" :tab="$t('model.haz.desc')" :forceRender="true">
                <HazLicenseDetailList
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        itemsKey= "hazLicenseDetails"
                        dataTempKey="refHazLicenseTemp"
                        :isLoading="isLoading"
                ></HazLicenseDetailList>
            </TabPane>
            <TabPane key="StorageLocationSub" v-if="data.useForm.modelRef?.refHazLicenseTemp?.refOperation?.key == '4'" :tab="$t('views.request.manufactureLocation.desc')" :forceRender="true">
                <HazLicenseStorageLocationList
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        itemsKey= "hazLicenseStorageLocations"
                        dataTempKey="refHazLicenseTemp"
                        :isLoading="isLoading"
                        :isLocation="false"
                ></HazLicenseStorageLocationList>
            </TabPane>
            <TabPane key="StorageLocation" :tab="$t('views.request.storageLocation.title')" :forceRender="true">
                <HazLicenseStorageLocationList
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        itemsKey= "hazLicenseStorageLocations"
                        dataTempKey="refHazLicenseTemp"
                        :isLoading="isLoading"
                ></HazLicenseStorageLocationList>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refHazLicenseTemp"
                        :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
            <TabPane key="Remark" v-if='data.userInfo?.refDepartment' :tab="$t('views.remark.text')" :forceRender="true">
                <RemarkInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></RemarkInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
    import { Card, Form, Tabs } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../app.logic";
    import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";
    import { has } from "../../../../utils/menu-context";

    export default defineComponent({
        components: {
            Card,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
            RequestorForm: defineAsyncComponent(() => import("../../storage-location/request/requestor/RequestorForm")),
            HazLicenseDetailList: defineAsyncComponent(() => import("./haz-license-detail/HazLicenseDetailList")),
            HazLicenseStorageLocationList: defineAsyncComponent(() => import("./haz-license-storage-location/HazLicenseStorageLocationList")),
            AttachmentForm: defineAsyncComponent(() => import("../../storage-location/request/attachment/AttachmentForm")),
            RemarkInfoForm: defineAsyncComponent(() => import("../../remark/RemarkInfoForm")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "haz-license-requests" },
            viewOnly: { default: false },
            form: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true },
            isLocation: { default: true },
            forceDefault: { default: false }
        },
        setup(props) {
            const route = useRoute();
            const id = props.form ? props.form.id : route.params?.id;
            const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ data }));
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                callOnClickModalOk,
                has
            };
        }
    });
</script>
